import React from 'react';
import PropTypes from 'prop-types';
import ArrowIcon from 'components/shared/icons/ArrowIcon';

class BackNavItem extends React.Component {
  static propTypes = {
    backHandler: PropTypes.func.isRequired,
    forceDisplay: PropTypes.bool,
  };

  render() {
    const hideOnSmallScreens = this.props.forceDisplay ? '' : 'visible-xs-block';
    return (
      <div className={hideOnSmallScreens}>
        <a className="btn btn-link" onClick={this.props.backHandler}>
          <span className="back-btn">
            <ArrowIcon className="workflow-nav-icon" direction="left" />
          </span>
        </a>
      </div>
    );
  }
}

export default BackNavItem;
